export default __webpack_public_path__ + "static/media/NothingSecret.a48400627f8bde00cf72e21b766fce07.webp";